//
//
//

import { parseJson } from '@/functions'

//
//
//

const isHttpCodeValid = status => [200, 201, 204, 400, 401, 403, 404, 409, 422, 424, 500].includes(status)

const localResponseObj = (reason, httpCode = 0) => ({
  code: 'LOCAL',
  title: 'Erro local',
  message: `A solicitação falhou. Por favor, tente novamente ou fale com o nosso suporte. ${reason}`,
  httpCode,
})

const httpRequest = args => {
  return new Promise((resolve, reject) => {
    console.log(`::: [DEBUG] ${args.method} ${args.url}:`, 'loading', args)

    if (!['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].includes(args.method || '') || !args.url) {
      resolve(localResponseObj('Motivo: Carga inválida.', 0))
    }

    // Set HTTP request settings
    const xhr = new XMLHttpRequest()
    xhr.open(args.method, args.url)

    // Default header
    xhr.setRequestHeader('Content-Type', 'application/json')

    // Inserção de todos os headers do objeto
    for (const key in args.headers) {
      if (args.headers.hasOwnProperty(key)) {
        xhr.setRequestHeader(key, args.headers[key])
      }
    }

    // Sets a 90-second timeout (1 minute and 30 seconds)
    xhr.timeout = 90000

    // Process the server response
    xhr.onload = () => {
      let response = xhr.status !== 204 ? parseJson(xhr.responseText) : { code: 'OK', title: 'Feito!', message: '' }

      console.log(`::: [DEBUG] ${args.method} ${args.url}:`, xhr.status || 'load', response || xhr.responseText)

      if (!response || !isHttpCodeValid(xhr.status)) {
        response = localResponseObj('Motivo: Resposta vazia ou inválida.')
      }

      resolve({ ...response, httpCode: xhr.status })
    }

    // Handle network failures or CORS-related issues
    xhr.onerror = () => {
      let response = parseJson(xhr.responseText)

      if (!response || !isHttpCodeValid(xhr.status)) {
        response = localResponseObj(`Motivo (error): ${xhr.statusText || 'Falha na rede ou erro desconhecido.'}`)
      }

      // resolve(localResponseObj(`Motivo (error): ${xhr.statusText || 'Falha na rede ou erro desconhecido.'}`, xhr.status || 0))
      resolve({ ...response, httpCode: xhr.status || 0 })
    }

    // Handles the timeout case (when the response takes longer than 10s)
    xhr.ontimeout = () => {
      resolve(localResponseObj('Motivo: A solicitação demorou e foi cancelada.', xhr.status || 0))
    }

    // Send the HTTP request
    try
    {
      if (args.payload) {
        xhr.send(JSON.stringify(args.payload))
      } else {
        xhr.send()
      }
    }
    catch (e)
    {
      console.log(`::: [DEBUG] ${args.method} ${args.url}:`, 'Erro ao enviar requisição', e)

      resolve(localResponseObj(`Motivo (send): ${e.message || 'O envio falhou.'}`, xhr.status || 0))
    }
  })
}

//
//
//

export {
  httpRequest,
}
